<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>
      <div class="query">
        <div class="query">
          <el-form ref="form" :inline="true" :model="form">
		    <el-form-item label="学期学年">
             <el-select v-model="form.value1" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in list1" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
             </el-select>
            </el-form-item> 
			 <el-form-item label="授课老师">
             <el-select v-model="form.value2" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in list2" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
             </el-select>
            </el-form-item> 
			<el-form-item label="投诉日期">
                <el-date-picker 
					v-model="form.selectData"
					type="daterange"
					style="width: 240px;"
					range-separator="-"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions">
					</el-date-picker>
            </el-form-item> 
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="w"
            label="投诉编号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="e"
            label="投诉时间"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="t"
            label="投诉订单号"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="t"
            label="授课教师"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="y"
            label="处理进度"
            show-overflow-tooltip
          >
          </el-table-column>
		    <el-table-column
            align="center"
            prop="u"
            label="投诉详情"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <!-- <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
// import store from '@/store';
export default {
  //   components: {
  //     Detail: () => import("./details.vue"),
  //   },
  data() {
    return {
      form: {
         value1: "",
         value2: "",
        selectData: "",
      },
	  selectList: [],
      semesterList: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 9,
      },

      info: "", // 出库单页面参数
     	tableData: [
		//  {w:'66531038',e:'2021/11/20 14:02:22', t:'46419391 ',    y:'已处理', u:'查看详情'},
		//  {w:'79859985',e:'2021/11/15 2:40:20',  t:'57365155 '  ,  y:'处理中', u:'查看详情'},
		//  {w:'65748839',e:'2021/11/15 3:57:08' , t:'69207084 ',    y:'已处理', u:'查看详情'},
		//  {w:'61319799',e:'2021/11/21 18:29:37', t:'64151427 '  ,  y:'已处理' ,u:'查看详情'},
		//  {w:'88139406',e:'2021/11/11 3:15:47',  t:'79880307 ',    y:'已处理' ,u:'查看详情'},
		//  {w:'83555681',e:'2021/11/9 10:06:40',  t:'67900555 ',    y:'已处理' ,u:'查看详情'},
		//  {w:'74066606',e:'2021/11/12 0:08:14',  t:'76572802  '  , y:'已处理' ,u:'查看详情'},
		//  {w:'79194062',e:'2021/11/21 7:22:35',  t:'54233562  '  , y:'处理中' ,u:'查看详情'},
		//  {w:'80497647',e:'2021/11/15 8:41:40',  t:'47829828  '  , y:'处理中' ,u:'查看详情'},
		 ],
		   list1:[
				{id:"1",label:"2021~2022年度下学期	  ",  value:"1"},
				{id:"2",label:"2021~2022年度上学期	 ",value:"2"},
				{id:"3",label:"2020~2021年度下学期	 ",  value:"3"},
				{id:"4",label:"2020~2021年度上学期	 ",value:"4"},
				{id:"5",label:"2019~2020年度下学期	 ",  value:"5"},
				{id:"6",label:"2019~2020年度上学期	  ",value:"6"},
			],
			list2:[
				{id:"1",label:"庄萍雅 ",  value:"1"},
				{id:"2",label:"杨萍蓓 ",value:"2"},
				{id:"3",label:"严姣婷 " ,  value:"3"},
				{id:"4",label:"昌琦嘉 ",value:"4"},
				{id:"5",label:"奚秋叶 ",  value:"5"},
				{id:"6",label:"强希礼 ",value:"6"},
				{id:"3",label:"明环凯 ",  value:"3"},
				{id:"4",label:"闫媛娣 ",value:"4"},
				{id:"5",label:"习华伊 ",  value:"5"},
				{id:"6",label:"寿歌姣 ",value:"6"},
			],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
	  pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
	  },
    };
  },
  mounted() {},
  created() {
    if (this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
    console.log("获取学年学期数据--", this.semesterList);
    // this.getDataList();
  },
  methods: {
    async getDataList() {
      if (this.form.selectData == "" || this.form.selectData == null) {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        teacherId: "",
        courseName: this.form.courseName,
        extOrgName: this.form.extOrgName,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.teacherCourseAttendance(params);
      console.log("获取考勤列表数据---", data);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
    //   console.log(scope);
    //   this.detail.info = scope.row;
    //   this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 160px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
